import { render } from "./leaveMessage.vue?vue&type=template&id=37618f91&scoped=true&ts=true"
import script from "./leaveMessage.vue?vue&type=script&lang=ts"
export * from "./leaveMessage.vue?vue&type=script&lang=ts"

import "./leaveMessage.vue?vue&type=style&index=0&id=37618f91&lang=less&scoped=true"
import "./leaveMessage.vue?vue&type=style&index=1&id=37618f91&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37618f91"]])

export default __exports__